import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";



export class ProjectMaintenanceServiceApi extends NewviewOaBaseApi {
  public get ControllerName(): any {
    return 'project-maintenance-service'
  }


 

}
